//const api = "http://127.0.0.1:8005/api/";
//export default api;

const api = "https://pmt-chiantla.jgjsystems.com/backend/public/api/";
export default api;

//const api = "/api/";
//export default api;